/**
 * 图片路径配置文件
 * 统一管理项目中使用的图片路径
 */

import { getImageUrl, getResponsiveImageUrls } from '../utils/imageUtils'

// Banner图片配置
export const bannerImages = {
  // 响应式Banner图片
  responsive: getResponsiveImageUrls('/images/banner'),
  // 加载中占位图片
  loading: getResponsiveImageUrls('/images/loading/banner')
}

// 软件图标配置
export const softwareIcons = {
  max3ds: getImageUrl('/images/3ds-max.png'),
  corona: getImageUrl('/images/Corona.png'),
  vray: getImageUrl('/images/V-Ray.png'),
  sketchup: getImageUrl('/images/sketchup.png'),
  maya: getImageUrl('/images/maya.png'),
  cinema4d: getImageUrl('/images/cinema4d.png'),
  blender: getImageUrl('/images/blender.png')
}

// 功能图标配置
export const functionIcons = {
  submit: getImageUrl('/images/icon-submit.png'),
  ao: getImageUrl('/images/icon-ao.png'),
  camera: getImageUrl('/images/icon-camera.png'),
  photon: getImageUrl('/images/icon-photon.png'),
  preview: getImageUrl('/images/icon-preview.png'),
  more: getImageUrl('/images/icon-more.png'),
  render: getImageUrl('/images/icon-render.png'),
  download: getImageUrl('/images/icon-download.png')
}

// 服务图标配置
export const serviceIcons = {
  server: getImageUrl('/images/icon-server.png'),
  dispatch: getImageUrl('/images/icon-dispatch.png'),
  support: getImageUrl('/images/icon-support.png'),
  security: getImageUrl('/images/icon-security.png'),
  speed: getImageUrl('/images/icon-speed.png'),
  quality: getImageUrl('/images/icon-quality.png')
}

// 轮播图配置
export const carouselImages = [
  {
    id: 1,
    url: getImageUrl('/images/carousel/rg2.jpg'),
    title: '渲染作品1'
  },
  {
    id: 2,
    url: getImageUrl('/images/carousel/rg3.jpg'),
    title: '渲染作品2'
  },
  {
    id: 3,
    url: getImageUrl('/images/carousel/rg4.jpg'),
    title: '渲染作品3'
  },
  {
    id: 4,
    url: getImageUrl('/images/carousel/rg8.jpg'),
    title: '渲染作品4'
  },
  {
    id: 5,
    url: getImageUrl('/images/carousel/rg9.jpg'),
    title: '渲染作品5'
  }
]

// 联系方式图标配置
export const contactIcons = {
  phone: getImageUrl('/images/icon-phone.png'),
  qq: getImageUrl('/images/icon-qq.png'),
  wechat: getImageUrl('/images/icon-wechat.png'),
  email: getImageUrl('/images/icon-email.png')
}

// 新闻页面图片配置
export const newsImages = {
  header: getImageUrl('/images/news/News_Center.png'),
  placeholder: getImageUrl('/images/news/placeholder.png')
}

// 西米工具箱图片配置
export const ximiImages = {
  logo: getImageUrl('/images/ximi/logo-xi.png'),
  features: {
    material: getImageUrl('/images/ximi/素材.png'),
    modeling: getImageUrl('/images/ximi/建模.png'),
    smart: getImageUrl('/images/ximi/智能.png'),
    antivirus: getImageUrl('/images/ximi/病毒查杀.png')
  },
  tips: {
    newUser: getImageUrl('/images/ximi/newUserTip.svg'),
    limitedTime: getImageUrl('/images/ximi/限时特惠.svg')
  },
  services: {
    free: getImageUrl('/images/ximi/免费.png'),
    recommend: getImageUrl('/images/ximi/精品推荐.png'),
    support: getImageUrl('/images/ximi/专属客服.png'),
    tutorial: getImageUrl('/images/ximi/官方教程.png'),
    login: getImageUrl('/images/ximi/账户登录.png')
  },
  animations: {
    singleSideModeling: getImageUrl('/images/ximi/单面建模.gif'),
    growthAnimation: getImageUrl('/images/ximi/生长动画.gif'),
    modelConversion: getImageUrl('/images/ximi/一键模型转换CAD.gif'),
    acesWorkflow: getImageUrl('/images/ximi/ACEScg工作流.gif'),
    smartMaterial: getImageUrl('/images/ximi/智能素材管理.gif')
  }
}

// 默认导出所有配置
export default {
  bannerImages,
  softwareIcons,
  functionIcons,
  serviceIcons,
  carouselImages,
  contactIcons,
  newsImages,
  ximiImages
}